import React from "react";
import { Typography } from "@mui/material";
import { useIntl } from "react-intl";

import type { CostResult } from "./aiModelCost";
import { formatMetric, formatMoney } from "./aiUsagePivot";

export const FfmpegAllocationCost: React.FC<{ result: CostResult }> = ({ result }) => {
  const intl = useIntl();
  if (!result.knownAllocationCount) return <>{intl.formatMessage({ id: "megen.cost.ffmpegNoUsdAllocation" })}</>;
  return <>
    <span>{formatMoney(result.cost)}</span>
    {result.missingRate && <Typography variant="caption" display="block">{intl.formatMessage({ id: "megen.cost.ffmpegPartialCost" })}</Typography>}
  </>;
};

export const FfmpegAllocationTime: React.FC<{ result: CostResult; seconds: number }> = ({ result, seconds }) => {
  const intl = useIntl();
  if (!result.knownAllocationTimeCount) return <>{intl.formatMessage({ id: "megen.cost.ffmpegTimeUnknown" })}</>;
  return <>
    <span>{intl.formatMessage({ id: "megen.cost.ffmpegAllocated" }, { seconds: formatMetric(seconds) })}</span>
    {result.quantityUnknown && <Typography variant="caption" display="block">{intl.formatMessage({ id: "megen.cost.ffmpegPartialTime" })}</Typography>}
  </>;
};
